import {get,post} from "../../../DAL/data-provider";
import {Response} from "../interfaces";



export const getWishListItems = async (purl:string) : Promise<Response> => {
    return get('/api/misc/wishlist/get-wishlist-items?wishListGuid=' + purl);
};
export const getUserWishlists = async () : Promise<Response> => {
    return get('/api/misc/wishlist/get-user-wishlists');
};

export const createNewWishList = async (newWishListName:string): Promise<Response> => {
    return post('/api/misc/wishlist/create-wishlist',
        {NewListName:newWishListName});
};
export const deleteWishList = async (itemID:number): Promise<Response> => {
    return post('/api/misc/wishlist/delete-wishlist',
        {ItemID:itemID});
};
export const deleteWishListItem = async (wishlistItemID:number): Promise<Response> => {
    return post('/api/misc/wishlist/delete-wishlist-item',
        {WishlistItemID:wishlistItemID});
};
export const renameWishlist = async (newName:string,wishlistID:number): Promise<Response> => {
    return post('/api/misc/wishlist/rename-wishlist',
        {WishlistID:wishlistID, NewName:newName});
};
export const insertItemToWishlist = async (newListName:string,toWishlistID:number,wishlistItemID:number): Promise<Response> => {
    return post('/api/misc/wishlist/move-wishlist-item',
        {ToWishlistID:toWishlistID,
              NewListName:newListName,
              WishlistItemID:wishlistItemID
            });
};
export const onLoadAddToWishlist = async (skuNumber:number,wishlistID:number,listName:string) : Promise<Response> => {
    return post('/api/misc/wishlist/load-add-item-to-wishlist',
        {Skuid:skuNumber,
              WishlistID:wishlistID,
              ListName:listName
            });
};
export const addItemToWishlist = async (skuNumber:number,wishlistID:number,listName:string) : Promise<Response> => {
    return post('/api/misc/wishlist/add-item-to-wishlist',
        {Skuid:skuNumber,
            WishlistID:wishlistID,
            ListName:listName
        });
};
